import React, { useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";

const IdleStatusConfirmForm = (props) => {
 
  let [remark, setRemark] = useState("");
  const [validate, setValidate] = useState(false);
  const { t } = useTranslation();
  const formRef = useRef(null);
 
  const handleConfirm = (event) => {
    const form = formRef.current;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidate(true);
      return;
    } else {
      setValidate(false);
      props.onConfirm(remark,props.reset);
    }
  };

  const handleCancel = () => {
    setRemark("");
    props.onHide();
  };

  const { show, onHide } = props;
  return (
    <>
      <Modal show={show} onHide={onHide} animation={false} backdrop="static">
        <ModalHeader
          title={t("msg_trasaction.msg_idle_status.confirm_idle_reason")}
        ></ModalHeader>
        <ModalBody>
          <Form noValidate validated={validate} ref={formRef}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="col-form-label">
                {t("msg_trasaction.msg_idle_status.remarks")} :
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Remark reason"
                value={remark || ""}
                onChange={(e) => setRemark(e.target.value)}
                required
                maxLength={Constants.MASTER.VALIDATION.maxLengthName}
                autoFocus
              />
              <Form.Control.Feedback type="invalid">
                {t("msg_trasaction.msg_idle_status.remark_validation")}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            variant="success"
            className="btn btn-success"
            onClick={handleConfirm}
          >
            {t("msg_common.confirm")}
          </Button>
          <Button
            type="button"
            variant="danger"
            className="btn btn-danger"
            onClick={handleCancel}
            data-dismiss="modal"
          >
            {t("msg_common.cancel")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default IdleStatusConfirmForm;
